<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Privacy" :submit="submit"
    :status="status">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <label>Descripcion</label>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description" solo rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from 'vuex';
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from '@/mixins/crud_form';

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: state => state.Privacy.status,
    })
  },
  data() {
    return {
      storeName: 'Privacy',
      title: "Politica de Privacidad",
      data: {
        title: "",
        description: '',
      }
    }
  }
}
</script>
